import React from 'react';
import { Typography } from '@mui/material';

import { ExclusiveIcon } from 'icons';

import { useStyles } from '../../styles';

const Exclusive = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.exclusive}>
      <ExclusiveIcon />
      <Typography variant="caption">Exclusive</Typography>
    </div>
  );
};

export default Exclusive;
